import React from "react";
import { Container } from "@mui/material";
import { InfoPortadaAdminInicio } from "../../../components/Admin/Inicio/PortadaAdmin";

export const PortadaInicioAdministrador = () =>{
    return(
        <Container maxWidth='xl'>
            <InfoPortadaAdminInicio/>
        </Container>
    )
}